export enum InviteType {
  User = 'user',
  EducationProvider = 'education_provider',
  EducationProviderLegalRepresentative = 'education_provider_legal_representative',
}

export interface IInvitation {
  _id?: string
  email: string
  role?: string
  team?: string
  token?: string
  expiresAt?: Date
  inviteType: InviteType
  usedAt?: Date
  deletedAt?: Date
  createdAt?: Date
  updatedAt?: Date
}

export interface IInvitationGetFilters {
  email?: string
  inviteType?: InviteType
  invitedBy?: string
}

export interface IInvitationCreatePayload {
  email: string
  role?: string
  inviteType: InviteType
}
